import React from 'react';
import { useTranslation } from 'react-i18next';
import { Active } from 'types';
import { CloseProductSection } from '../../components/CloseProductSection';
import { ExternalServicingUsersConfigurationSection } from '../../components/ExternalServicingUsersConfigurationSection';
import { useCloseConfigureModal } from '../../hooks/useCloseConfigureModal';
import { useDeactivateExternallyServicedProduct } from '../../hooks/useDeactivateExternallyServicedProduct';
import { useGenericCloseBodyText } from '../../hooks/useGenericCloseBodyText';
import { ConfigureProductDialog } from '../../shell/ConfigureProductDialog';
import type { ConfigureProductGroupModalProps } from '../configureProductGroupModalProps';
import { getExternalServicingUsersProductConfig } from './externalServicingUsersProductConfig';

export const ExternalServicingUsersModal: React.FC<ConfigureProductGroupModalProps> = ({ serviceAgreement, brUid }) => {
  const { t } = useTranslation();
  const config = getExternalServicingUsersProductConfig(serviceAgreement.serviceDefinitionId);
  const { close, isClosing } = useDeactivateExternallyServicedProduct(serviceAgreement, brUid);
  const genericCloseBodyText = useGenericCloseBodyText();
  const closeBodyText =
    serviceAgreement.agreementStatus === Active.ACTIVE ? t(config.activeCloseBodyTextKey) : genericCloseBodyText;
  const handleClose = useCloseConfigureModal(false);
  const disabledCloseReasonKey = config.getCloseDisabledReasonKey(serviceAgreement);

  return (
    <ConfigureProductDialog
      title={t(config.titleKey)}
      width={config.width}
      size={config.size}
      isPending={false}
      onClose={handleClose}
      footer={{
        canSave: false,
        saveBlockedReasons: [],
        showSave: false,
        closeLabel: t('pb.configureproductmodal.wealthplanning.close'),
      }}
    >
      <ExternalServicingUsersConfigurationSection product={config.configurationSectionProduct} />
      <CloseProductSection
        isPending={false}
        bodyText={closeBodyText}
        addTopMargin
        disabledReason={disabledCloseReasonKey ? t(disabledCloseReasonKey) : null}
        isClosing={isClosing}
        onConfirmClose={close}
      />
    </ConfigureProductDialog>
  );
};
